// Derivación de la ráfaga X/Y (ADR 0004 §3): X = 3 + (u32(HMAC(seed, "pre" ‖ u32(i))[0..4]) mod 6).
import { concatBytes, fromHex, hmacSha256, u32, utf8 } from './crypto.js';

export const BURST_MIN = 3;
export const BURST_SPAN = 6;

/** Forma de una ráfaga: fotogramas antes (X) y después (Y) del elegido. */
export interface BurstShape {
  pre: number;
  post: number;
}

async function draw(seed: Uint8Array, label: string, index: number): Promise<number> {
  const mac = await hmacSha256(seed, concatBytes(utf8(label), u32(index)));
  const word = new DataView(mac.buffer, mac.byteOffset, 4).getUint32(0, false);
  return BURST_MIN + (word % BURST_SPAN);
}

/** X e Y del disparo `index` a partir del `seed` de sesión (64 hex). */
export async function deriveBurst(seedHex: string, index: number): Promise<BurstShape> {
  if (!/^[0-9a-f]{64}$/.test(seedHex)) throw new TypeError('invalid_seed');
  const seed = fromHex(seedHex);
  return { pre: await draw(seed, 'pre', index), post: await draw(seed, 'post', index) };
}
